import TriggerHandlerBase from '../trigger-handler-base';
import { isMatchingUrls } from '../../../../utils';

export default class InViewTriggerHandler extends TriggerHandlerBase {
  constructor(ctx, nodeService) {
    super(ctx, nodeService, 'elementIdentifier');
    window.addEventListener('scroll', this.#onScroll.bind(this));
  }

  static isInViewport(selector) {
    if (!selector) {
      return false;
    }

    const els = document.querySelectorAll(selector);

    return Array.from(els).find((el) => {
      const rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    });
  }

  initiate() {
    // Watching current route in store to also check on inital pageload
    this.store.watch(
      (localstate) => localstate.pageLoadTriggerStore?.route,
      (newValue) => {
        if (!newValue) {
          return;
        }

        this.#onScroll();
      },
      { immediate: true }
    );

    this.isInitiated = true;
  }

  getTriggers() {
    return this.store.getters['chatbotStore/getTriggers']?.filter((trigger) => trigger.elementIdentifier) ?? [];
  }

  #onScroll() {
    const route = this.store.getters['pageLoadTriggerStore/currentRoute'];
    const trigger = this.getTriggers().find((tgr) => {
      try {
        return isMatchingUrls(route, tgr) && InViewTriggerHandler.isInViewport(tgr.elementIdentifier);
      } catch (error) {
        return false;
      }
    });

    if (trigger) {
      this.startConversation(trigger);
    }
  }
}
